import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import type { SystemHealth } from "@/types";

// #239 C1: aggregierte System-Health (alle Komponenten). Live-Polling alle 15s.
export function useSystemHealth(): UseQueryResult<SystemHealth> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: ["resources", "system-health"],
    queryFn: () => {
      const client = createApiClient({ getToken: () => session?.accessToken ?? null, onUnauthorized: logout });
      return client.get<SystemHealth>("/health/system");
    },
    enabled: !!session,
    refetchInterval: 15_000,
  });
}
